import { render, staticRenderFns } from "./CompetitorRanking.vue?vue&type=template&id=0a73915b&scoped=true&"
import script from "./CompetitorRanking.vue?vue&type=script&lang=js&"
export * from "./CompetitorRanking.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorRanking.vue?vue&type=style&index=0&id=0a73915b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73915b",
  null
  
)

export default component.exports